import React, { useState, useRef, useEffect } from "react";
import LockImage from "../../assets/lockbox.png";
import {
  FaEdit,
  FaChevronDown,
  FaChevronUp,
  FaSave,
  FaTimes,
  FaPlus,
  FaTrash,
} from "react-icons/fa";
import {
  CheckBoxSelection,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns";
import {
  GridComponent,
  ColumnDirective,
  CommandColumn,
  ColumnsDirective,
  Inject,
  Page,
  Edit,
  Toolbar,
  Sort,
  Filter,
  ColumnMenu,
} from "@syncfusion/ej2-react-grids";
import { UploaderComponent, Uploader } from "@syncfusion/ej2-react-inputs";
import { ImageDialog } from "../Disasters/AssistanceLog";
import LockBoxService from "../../service/citizen/LockboxService";
import { db, auth } from "../../firebase";
import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
  deleteObject,
  uploadBytes,
} from "firebase/storage";
import { Query } from "@syncfusion/ej2-data";
import { encrypt, decrypt } from "../../service/encryption/Encryption";
import ShowPin from "../Profile-Popup/ShowPin";
import { useLocation } from "react-router-dom";
import { query, where } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import FileDialog from "../FileViewerModal";

const sortSettings = {
  allowSorting: true,
};

const editing = {
  allowDeleting: true,
  allowAdding: true,
  allowEditing: true,
  showDeleteConfirmDialog: true,
  mode: "Dialog",

  dialog: { cssClass: "custom-dialog" },
};

const filterSettings = {
  type: "CheckBox",
};

const columnMenuItems = ["SortAscending", "SortDescending", "Filter"];

const pageSettings = { pageSize: 10 };

const datepickerparams = {
  params: {
    format: "MM/dd/yyyy",
    value: new Date(),
    showClearButton: false,
    showTodayButton: false,
    start: "Decade",
    depth: "Day",
  },
};

const documentTypes = [
  { idName: "ID", id: "1" },
  { idName: "Credit Cards/Banking Information", id: "2" },
  { idName: "Insurance Information", id: "3" },
  { idName: "Photos", id: "4" },
  { idName: "Titles/Deed/Registration", id: "5" },
];

const typeParams = {
  params: {
    allowFiltering: true,
    dataSource: documentTypes,
    fields: { text: "idName", value: "idName" },
    query: new Query(),
  },
};

const statusOptions = [
  { text: "Active", value: "Active" },
  { text: "Inactive", value: "Inactive" },
];

const statusParams = {
  params: {
    dataSource: statusOptions,
    fields: { text: "text", value: "value" },
    allowFiltering: true,
    query: new Query(),
  },
};

const PartnershipDocuments = ({ className = "" }) => {
  const [userId, setUserId] = useState(null);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [documentsData, setDocumentsData] = useState([]);
  const [PhotosData, setPhotosData] = useState([]);
  const [centerDocumentsData, setCenterDocumentsData] = useState([]);
  const [isImageDialogOpen, setIsImageDialogOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isSyncModalOpen, setIsSyncModalOpen] = useState(false);
  const [syncDocumentData, setSyncDocumentData] = useState(null);
  const [syncSuccess, setSyncSuccess] = useState(false);
  const [isFileDialogOpen, setIsFileDialogOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [selectedDataSet, setDataSet] = useState("");
  const location = useLocation();
  const selectedUserId = sessionStorage.getItem("userId");

  useEffect(() => {
    const fetchUserUID = async () => {
      if (location.state?.partnerUserId) {
        try {
          const usersRef = collection(db, "users");
          const q = query(
            usersRef,
            where("partner_id", "==", location.state.partnerUserId)
          );

          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0];
            setUserId(userDoc.id);
          } else {
            console.warn("No user found with this ID.");
          }
        } catch (error) {
          console.error("Error fetching user UID:", error);
        }
      }
    };

    fetchUserUID();
  }, [location.state?.partnerUserId]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser && selectedUserId) {
        try {
          const userDocRef = doc(db, "users", selectedUserId);
          const userDocSnap = await getDoc(userDocRef);

          if (!userDocSnap.exists()) {
            console.error("No such user document!");
            return;
          }

          const userData = userDocSnap.data();
          if (!userData.center_id) {
            console.error("User does not have a center_id.");
            return;
          }

          const centerDocRef = doc(db, "centers", userData.center_id);
          const centerDocSnap = await getDoc(centerDocRef);

          if (!centerDocSnap.exists()) {
            console.error("No such center document!");
            return;
          }

          const centerData = { id: centerDocSnap.id, ...centerDocSnap.data() };
          setCurrentData(centerData);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      } else {
        setCurrentData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userId) {
      fetchData();
    }
  }, [userId]);

  const fetchData = async () => {
    try {
      // Fetch user document
      const userDocRef = doc(db, "users", userId);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        setData({ id: userDoc.id, ...userDoc.data() });

        const documents = await LockBoxService.fetchDocumentsFromLockbox(
          userId,
          "documents_data"
        );

        const photos = await LockBoxService.fetchDocumentsFromLockbox(
          userId,
          "photos_data"
        );

        const centerDocuments = await LockBoxService.fetchDocumentsFromLockbox(
          userId,
          "center_documents"
        );

        const activeDocuments = documents.filter(
          (doc) => doc.is_deleted !== true
        );

        setDocumentsData(activeDocuments);

        const activePhotos = photos.filter(
          (photo) => photo.is_deleted !== true
        );

        setPhotosData(activePhotos);

        const activeCenterDocuments = centerDocuments.filter(
          (doc) => doc.is_deleted !== true && doc.status !== "Inactive"
        );

        setCenterDocumentsData(activeCenterDocuments);
      } else {
        console.error("No such document!");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  let elem;
  let uploadObj;
  let strm;
  let selectedRow;

  function compressImage(file, maxSizeMB) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function (event) {
        const img = new Image();
        img.src = event.target.result;

        img.onload = function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          const maxWidth = img.width;
          const maxHeight = img.height;
          let width = img.width;
          let height = img.height;

          // Resize the image maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height = Math.floor((height *= maxWidth / width));
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.floor((width *= maxHeight / height));
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);

          let quality = 0.9; // Start with high quality
          let dataUrl = canvas.toDataURL("image/jpeg", quality);

          // Compress the image by reducing quality until it's below maxSizeMB
          while (dataUrl.length / 1024 / 1024 > maxSizeMB && quality > 0.1) {
            quality -= 0.1;
            dataUrl = canvas.toDataURL("image/jpeg", quality);
          }

          resolve(dataUrl);
        };

        img.onerror = function (error) {
          reject(error);
        };
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  async function uploadFileToStorage(filePath, fileData, fileType) {
    const storage = getStorage();
    const timestamp = Date.now();
    const uniqueFilePath = `${filePath.split(".")[0]}_${timestamp}.${
      filePath.split(".")[1]
    }`;
    const storageRef = ref(storage, uniqueFilePath);

    if (fileType.startsWith("image/")) {
      await uploadString(storageRef, fileData, "data_url");
    } else {
      await uploadBytes(storageRef, fileData);
    }

    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  }

  const handleFileClick = (files, documentData) => {
    if (Array.isArray(files) && files.length > 0) {
      setSelectedFiles(files);
      setCurrentFileIndex(0);
      setIsFileDialogOpen(true);
    }
    setDataSet(documentData);
  };

  // Add this component to your render method
  // const FileDialog = ({
  //   isOpen,
  //   onClose,
  //   files,
  //   currentIndex,
  //   setCurrentIndex,
  //   dataset,
  // }) => {
  //   const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  //   const [centerAcknowledged, setCenterAcknowledged] = useState(
  //     dataset.center_acknowledged || false
  //   );

  //   if (!isOpen || !Array.isArray(files) || files.length === 0) return null;

  //   const file = files[currentIndex];
  //   const isImage = file.type && file.type.startsWith("image/");
  //   const fileName = file.name || "Untitled File";
  //   const requiresSignature = dataset.center_signature_required === true;
  //   const showAcknowledgment = dataset.copied_at && !requiresSignature;
  //   const name = `${currentData.first_name} ${currentData.last_name}`;

  //   let signature = dataset.center_signature || "";

  //   const handleSignatureChange = (event) => {
  //     const inputValue = event.target.value;
  //     const sanitizedValue = inputValue.replace(/[^a-zA-Z\s]/g, "");
  //     signature = sanitizedValue;
  //   };

  //   const handleSaveSignature = async () => {
  //     try {
  //       await LockBoxService.updateDocumentInLockbox(
  //         userId,
  //         dataset.documentsID,
  //         {
  //           center_signature: signature,
  //           center_signed_at: new Date().toISOString(),
  //           center_signed_by: name,
  //         },
  //         "center_documents"
  //       );
  //       setShowSuccessDialog(true);
  //     } catch (error) {
  //       console.error("Error saving signature:", error);
  //     }
  //   };

  //   const handleAcknowledgmentChange = async (event) => {
  //     const acknowledged = event.target.checked;
  //     setCenterAcknowledged(acknowledged);

  //     try {
  //       await LockBoxService.updateDocumentInLockbox(
  //         userId,
  //         dataset.documentsID,
  //         {
  //           center_acknowledged: acknowledged,
  //           center_acknowledged_by: acknowledged ? name : "",
  //           center_acknowledged_date: acknowledged
  //             ? new Date().toISOString()
  //             : "",
  //         },
  //         "center_documents"
  //       );
  //       setShowSuccessDialog(true);
  //     } catch (error) {
  //       console.error("Error saving acknowledgment:", error);
  //     }
  //   };

  //   const handlePrev = () => {
  //     setCurrentIndex((prevIndex) =>
  //       prevIndex > 0 ? prevIndex - 1 : files.length - 1
  //     );
  //   };

  //   const handleNext = () => {
  //     setCurrentIndex((prevIndex) =>
  //       prevIndex < files.length - 1 ? prevIndex + 1 : 0
  //     );
  //   };

  //   const handleBackgroundClick = (e) => {
  //     if (e.target === e.currentTarget) {
  //       onClose();
  //     }
  //   };

  //   return (
  //     <>
  //       {/* Main File Dialog */}
  //       <div
  //         className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
  //         onClick={handleBackgroundClick}
  //       >
  //         <div className="relative flex h-[80vh] w-full max-w-4xl flex-col">
  //           {/* Header */}
  //           <div className="absolute left-0 right-0 top-0 flex items-center justify-between rounded-t-lg bg-black bg-opacity-50 p-4 text-white">
  //             <h2 className="text-xl truncate font-bold">{fileName}</h2>
  //             <button
  //               onClick={onClose}
  //               className="text-3xl flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-black bg-opacity-50 text-white transition-all hover:bg-opacity-75"
  //             >
  //               &times;
  //             </button>
  //           </div>

  //           {/* Viewer */}
  //           <div className="relative mt-16 flex-grow bg-black">
  //             {isImage ? (
  //               <div className="absolute inset-0 flex items-center justify-center">
  //                 <img
  //                   src={file.src}
  //                   alt={fileName}
  //                   className="max-h-full max-w-full object-contain"
  //                 />
  //               </div>
  //             ) : (
  //               <iframe
  //                 src={file.src}
  //                 title={fileName}
  //                 className="absolute inset-0 h-full w-full"
  //               />
  //             )}
  //             {files.length > 1 && (
  //               <>
  //                 <button
  //                   onClick={handlePrev}
  //                   className="absolute left-4 top-1/2 flex h-12 w-12 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-black bg-opacity-50 text-white transition-all hover:bg-opacity-75"
  //                 >
  //                   &lt;
  //                 </button>
  //                 <button
  //                   onClick={handleNext}
  //                   className="absolute right-4 top-1/2 flex h-12 w-12 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-black bg-opacity-50 text-white transition-all hover:bg-opacity-75"
  //                 >
  //                   &gt;
  //                 </button>
  //               </>
  //             )}
  //           </div>
  //           {/* Footer */}
  //           <div className="flex items-center justify-between bg-black bg-opacity-50 p-4 text-white">
  //             <p className="text-sm">
  //               {isImage ? "Image" : "Document"} {currentIndex + 1} of{" "}
  //               {files.length}
  //             </p>
  //           </div>

  //           {/* Signature or Acknowledgment Input */}
  //           {requiresSignature ? (
  //             // Signature Input
  //             <div className="flex items-center justify-between gap-4 rounded-b-lg bg-black bg-opacity-50 p-4 text-white">
  //               <div className="text-gray-700 w-40 text-sm font-medium">
  //                 <p>Sign here:</p>
  //               </div>
  //               <input
  //                 type="text"
  //                 className="mt-1 w-full rounded-md border border-gray-300 p-2"
  //                 defaultValue={signature}
  //                 onChange={handleSignatureChange}
  //                 placeholder="Sign Here"
  //                 maxLength={50}
  //                 onInput={(e) => {
  //                   e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
  //                 }}
  //               />
  //               <button
  //                 className="mt-2 rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-600"
  //                 onClick={handleSaveSignature}
  //               >
  //                 Save
  //               </button>
  //             </div>
  //           ) : showAcknowledgment ? (
  //             // Acknowledgment Checkbox (only if copied_at is missing)
  //             <div className="flex items-center justify-between gap-4 rounded-b-lg bg-black bg-opacity-50 p-4 text-white">
  //               <div className="flex items-center gap-3">
  //                 <input
  //                   type="checkbox"
  //                   checked={centerAcknowledged}
  //                   onChange={handleAcknowledgmentChange}
  //                   className="h-5 w-5"
  //                 />
  //                 <label className="text-sm text-white">
  //                   Do you acknowledge this document?
  //                 </label>
  //               </div>
  //             </div>
  //           ) : null}
  //         </div>
  //       </div>

  //       {/* Success Dialog */}
  //       {showSuccessDialog && (
  //         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  //           <div className="rounded-lg bg-white p-6 text-center shadow-lg">
  //             <h2 className="text-lg font-semibold text-green-600">
  //               {requiresSignature
  //                 ? "Signature Saved Successfully"
  //                 : "Acknowledgment Saved Successfully"}
  //             </h2>
  //             <button
  //               className="mt-4 rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
  //               onClick={() => setShowSuccessDialog(false)}
  //             >
  //               Close
  //             </button>
  //           </div>
  //         </div>
  //       )}
  //     </>
  //   );
  // };

  const documentsTemplate = (props) => {
    const files = Array.isArray(props.photodocuments)
      ? props.photodocuments
      : props.photodocuments
      ? [props.photodocuments]
      : [];

    const documentCount = files.length;

    return (
      <div
        className="image-name-container"
        onClick={() => documentCount > 0 && handleFileClick(files, props)}
        style={{
          cursor: documentCount > 0 ? "pointer" : "default",
          padding: "5px",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          textAlign: "center",
          minWidth: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#3B82F6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginRight: "8px" }}
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <p className="text-sm">
          {documentCount > 0
            ? `${documentCount} document${documentCount > 1 ? "s" : ""}`
            : "None"}
        </p>
      </div>
    );
  };

  const documentsEdit = {
    create: () => {
      elem = document.createElement("div");
      return elem;
    },
    read: () => {
      return strm;
    },
    destroy: () => {
      if (uploadObj) {
        uploadObj.destroy();
      }
      strm = null;
    },
    write: (args) => {
      const path = {
        removeUrl:
          "https://services.syncfusion.com/react/production/api/FileUploader/Remove",
        saveUrl:
          "https://services.syncfusion.com/react/production/api/FileUploader/Save",
      };

      elem.innerHTML = `
        <div class="flex flex-col justify-center w-full">
          <div id="documentsPreviews" class="mb-4 flex flex-wrap justify-center gap-2">
            <!-- Documents will be dynamically inserted here -->
          </div>
          
          <div id="dropArea">
            <label class="upload-button cursor-pointer flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" id="uploadLabel">
              <svg class="mr-2 -ml-1 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Upload Documents
            </label>
            <input type="file" id="defaultUpload" style="display:none;" multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
          </div>
          <div id="uploadProgress" class="w-full bg-gray-200 rounded-full h-2.5 mt-4" style="display: none;">
            <div class="bg-blue-600 h-2.5 rounded-full" style="width: 0%;"></div>
          </div>
        </div>
      `;

      const inputElement = elem.querySelector("#defaultUpload");
      const uploadLabel = elem.querySelector("#uploadLabel");
      const documentsPreviews = elem.querySelector("#documentsPreviews");
      const uploadProgressContainer = elem.querySelector("#uploadProgress");
      const uploadProgressBar = uploadProgressContainer.querySelector("div");

      uploadProgressContainer.style.cssText += `
      margin-top: 1rem;
      background-color: #e5e7eb;
      border-radius: 0.5rem;
      overflow: hidden;
    `;

      uploadProgressBar.style.cssText += `
      height: 0.5rem;
      background-color: #3b82f6;
      transition: width 0.3s ease;
      border-radius: 0.5rem;
    `;

      uploadObj = new Uploader({
        asyncSettings: path,
        success: onUploadSuccess,
        failure: onUploadFailure,
        progress: onUploadProgress,
        multiple: true,
        allowedExtensions: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
        cssClass: "hidden",
      });

      uploadObj.appendTo(inputElement);

      uploadLabel.addEventListener("click", () => {
        inputElement.click();
      });

      inputElement.addEventListener("change", () => {
        if (inputElement.files.length > 0) {
          uploadObj.upload(inputElement.files);
        }
      });

      async function onUploadSuccess(args) {
        if (args.operation === "upload") {
          try {
            // Show progress bar at 90% during processing
            uploadProgressContainer.style.display = "block";
            uploadProgressBar.style.width = "90%";
            uploadProgressBar.style.transition = "width 0.3s ease";

            const file = args.file.rawFile;
            let fileData = file;
            let isImage = file.type.startsWith("image/");

            if (isImage) {
              fileData = await compressImage(file, 1);
            }

            const filePath = `lockbox/documents/${userId}/${file.name}`;
            const downloadURL = await uploadFileToStorage(
              filePath,
              fileData,
              file.type
            );

            strm = strm
              ? [
                  ...strm,
                  { src: downloadURL, name: file.name, type: file.type },
                ]
              : [{ src: downloadURL, name: file.name, type: file.type }];

            uploadProgressBar.style.width = "100%";

            setTimeout(() => {
              displayUploadedDocuments(strm);

              setTimeout(() => {
                uploadProgressContainer.style.display = "none";
                uploadProgressBar.style.width = "0%";
                uploadProgressBar.style.transition = "none";
              }, 300);
            }, 500);
          } catch (error) {
            console.error("Error during upload:", error);
            uploadProgressBar.style.backgroundColor = "#ef4444";
            setTimeout(() => {
              uploadProgressContainer.style.display = "none";
              uploadProgressBar.style.width = "0%";
              uploadProgressBar.style.backgroundColor = "#3b82f6";
            }, 2000);
          }
        }
      }

      function onUploadFailure(args) {
        console.log("File failed to upload");
      }

      function onUploadProgress(args) {
        const progress = Math.round((args.e.loaded / args.e.total) * 100);
        const displayProgress = Math.min(progress, 80);
        uploadProgressContainer.style.display = "block";
        uploadProgressBar.style.width = `${displayProgress}%`;
        uploadProgressBar.style.transition = "width 0.3s ease";
      }

      function displayUploadedDocuments(documents) {
        if (!Array.isArray(documents)) {
          console.error("Documents is not an array:", documents);
          return;
        }

        documentsPreviews.innerHTML = `
          <div class="loading-placeholder w-20 h-20 bg-gray-100 rounded-md animate-pulse">
            <div class="flex items-center justify-center h-full">
              <svg class="animate-spin h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </div>
        `;

        setTimeout(() => {
          documentsPreviews.innerHTML = documents
            .map(
              (doc, index) => `
              <div class="relative group">
                <div class="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-md">
                  ${getDocumentIcon(doc.type)}
                </div>
                <p class="text-xs text-center mt-1 truncate w-20">${
                  doc.name
                }</p>
                <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <button onclick="removeDocument(${index})" class="text-white hover:text-red-500">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
            `
            )
            .join("");
        }, 300);
      }

      function getDocumentIcon(fileType) {
        if (fileType.startsWith("image/")) {
          return `<svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>`;
        } else {
          return `<svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>`;
        }
      }

      // Function to remove a document
      window.removeDocument = (index) => {
        strm.splice(index, 1);
        displayUploadedDocuments(strm);
      };

      // Display the initial documents if available
      if (args.rowData.photodocuments) {
        strm = Array.isArray(args.rowData.photodocuments)
          ? args.rowData.photodocuments
          : [args.rowData.photodocuments];
        displayUploadedDocuments(strm);
      } else {
        documentsPreviews.innerHTML = "";
      }
    },
  };

  function generateUniqueId(length = 28) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  const sanitizeData = (data) => {
    const sanitizedData = {};
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[key] !== undefined) {
        sanitizedData[key] = data[key];
      }
    }
    return sanitizedData;
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const [selectedSignature, setSelectedSignature] = useState(null);

  const openSignatureDetails = (data, type) => {
    setSelectedSignature({ data, type });
  };

  const closeSignatureDetails = () => {
    setSelectedSignature(null);
  };

  const signatureTemplateCenter = (props) => {
    if (props.center_signature_required) {
      return props.center_signature ? (
        <span
          className="cursor-pointer rounded bg-blue-500 px-3 py-1 text-white"
          onClick={() => openSignatureDetails(props, "center_signature")}
        >
          Signed
        </span>
      ) : (
        <span>Not Signed</span>
      );
    } else if (!props.center_signature_required) {
      return props.center_acknowledged ? (
        <span
          className="cursor-pointer rounded bg-blue-500 px-3 py-1 text-white"
          onClick={() => openSignatureDetails(props, "center_acknowledged")}
        >
          Acknowledged
        </span>
      ) : (
        <span>Not Acknowledged</span>
      );
    } else {
      return <span>Not Required</span>;
    }
  };

  const signatureTemplatePartner = (props) => {
    if (props.partner_signature_required) {
      return props.partner_signature ? (
        <span
          className="cursor-pointer rounded bg-blue-500 px-3 py-1 text-white"
          onClick={() => openSignatureDetails(props, "partner_signature")}
        >
          Signed
        </span>
      ) : (
        <span>Not Signed</span>
      );
    } else if (!props.partner_signature_required) {
      return props.partner_acknowledged ? (
        <span
          className="cursor-pointer rounded bg-blue-500 px-3 py-1 text-white"
          onClick={() => openSignatureDetails(props, "partner_acknowledged")}
        >
          Acknowledged
        </span>
      ) : (
        <span>Not Acknowledged</span>
      );
    } else {
      return <span>Not Required</span>;
    }
  };

  const SignatureDetailsModal = ({ selectedSignature, onClose }) => {
    if (!selectedSignature) return null;

    const { data, type } = selectedSignature;
    let title = "";
    let details = [];

    if (type === "center_signature") {
      title = "Center Signature Details";
      details = [
        { label: "Center Signature", value: data.center_signature },
        { label: "Signed At", value: formatDate(data.center_signed_at) },
        { label: "Signed By", value: data.center_signed_by },
      ];
    } else if (type === "center_acknowledged") {
      title = "Center Acknowledgment Details";
      details = [
        {
          label: "Center Acknowledged",
          value: data.center_acknowledged ? "Yes" : "No",
        },
        { label: "Acknowledged By", value: data.center_acknowledged_by },
        {
          label: "Acknowledged Date",
          value: formatDate(data.center_acknowledged_date),
        },
      ];
    } else if (type === "partner_signature") {
      title = "Partner Signature Details";
      details = [
        { label: "Partner Signature", value: data.partner_signature },
        { label: "Signed At", value: formatDate(data.partner_signed_at) },
        { label: "Signed By", value: data.partner_signed_by },
      ];
    } else if (type === "partner_acknowledged") {
      title = "Partner Acknowledgment Details";
      details = [
        {
          label: "Partner Acknowledged",
          value: data.partner_acknowledged ? "Yes" : "No",
        },
        { label: "Acknowledged By", value: data.partner_acknowledged_by },
        {
          label: "Acknowledged Date",
          value: formatDate(data.partner_acknowledged_date),
        },
      ];
    }

    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="w-[440px] rounded-lg bg-white shadow-lg">
          <div className="flex items-center justify-between rounded-t-lg bg-[#467ba4] p-4">
            <p className="font-semibold text-[#fdb841]">{title}</p>
            <button
              className="cursor-pointer bg-[#467ba4] text-[20px] font-semibold text-[#fdb841]"
              onClick={onClose}
            >
              ×
            </button>
          </div>
          <div className="space-y-2 p-4">
            {details.map((item, index) => (
              <p key={index}>
                <strong>{item.label}:</strong> {item.value || "N/A"}
              </p>
            ))}
          </div>
          <div className="my-4 flex justify-center">
            <button
              onClick={onClose}
              className="btn-cancel justify-center rounded px-4 py-2 text-white hover:bg-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  //CENTER DOCUMENTS
  const centerDocumentGridRef = useRef(null);

  const handleAddClickCenterDocument = () => {
    if (centerDocumentGridRef.current) {
      centerDocumentGridRef.current.addRecord();
    }
  };

  const actionBeginCenterDocuments = async (args) => {
    if (args.requestType === "beginEdit") {
      if (args.rowData.copied_at) {
        args.cancel = true;
        return;
      }
      selectedRow = args.rowData;
    }

    if (centerDocumentGridRef.current) {
      const cols = centerDocumentGridRef.current.columns;
      const hideOnEditAdd = ["Actions", "Sync", "center_signature"];
      const showOnEditAdd = [
        "center_signature_required",
        "partner_signature_required",
      ];

      if (["beginEdit", "add"].includes(args.requestType)) {
        cols.forEach((col) => {
          if (hideOnEditAdd.includes(col.field || col.headerText)) {
            col.visible = false;
          }
          if (showOnEditAdd.includes(col.field)) {
            col.visible = true;
          }
        });
      }

      if (args.requestType === "save") {
        cols.forEach((col) => {
          if (hideOnEditAdd.includes(col.field || col.headerText)) {
            col.visible = true; // Show hidden fields after saving
          }
          if (showOnEditAdd.includes(col.field)) {
            col.visible = false; // Hide fields after saving
          }
        });
      }
    }

    if (args.requestType === "save" && args.action === "add") {
      args.data.documentsID = generateUniqueId();
      args.data.is_deleted = false;
      args.data.date = formatDate(args.data.date || new Date());

      if (args.data.date) {
        const dateObj = new Date(args.data.date);
        args.data.date = dateObj.toLocaleDateString("en-US");
      }

      const sanitizedData = sanitizeData(args.data);
      await LockBoxService.addDocumentToLockbox(
        userId,
        sanitizedData,
        "center_documents"
      );
    }

    if (args.requestType === "beginEdit") {
      selectedRow = args.rowData;
    }

    if (args.requestType === "delete") {
      try {
        for (const docData of args.data) {
          await LockBoxService.softDeleteItemInLockbox(
            userId,
            docData.id,
            "center_documents"
          );
        }
        fetchData();
      } catch (error) {
        console.error("Error deleting document:", error);
      }
    }
  };

  const actionCompleteCenterDocuments = async (args) => {
    if (args.requestType === "save" && args.action === "edit") {
      try {
        const documentId = selectedRow.documentsID;

        if (args.data.date) {
          const dateObj = new Date(args.data.date);
          args.data.date = dateObj.toLocaleDateString("en-US");
        }

        args.data.photodocuments = args.data.photodocuments || [];
        const sanitizedData = sanitizeData(args.data);

        await LockBoxService.updateDocumentInLockbox(
          userId,
          documentId,
          sanitizedData,
          "center_documents"
        );

        const updatedData = centerDocumentsData.map((item) =>
          item.documentsID === documentId ? sanitizedData : item
        );

        setCenterDocumentsData(updatedData);
      } catch (error) {
        console.error("Error updating document:", error);
      }
    }
    if (args.requestType === "beginEdit") {
      const datepicker = args.form.elements["date"];
      if (datepicker && datepicker.ej2_instances[0]) {
        datepicker.ej2_instances[0].value = new Date(args.rowData.date);
      }
    }
    if (args.requestType === "beginEdit" || args.requestType === "add") {
      const dialog = args.dialog;
      dialog.header =
        args.requestType === "beginEdit" ? "Edit " : "Add New Record";
    }
  };

  const SyncConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
      <div className="bg-gray-900 fixed inset-0 flex items-center justify-center bg-opacity-50">
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center ">
          <div className="flex w-[440px] justify-between rounded-t-lg bg-[#467ba4] p-4 ">
            <p className="font-semibold text-[#fdb841]">Sync Document</p>
            <div className="cursor-pointer text-[#fdb841]" onClick={onClose}>
              x
            </div>
          </div>
          <div className="w-[440px] rounded-b-lg bg-white p-6 text-center shadow-lg">
            <div
              className="flex items-center justify-center"
              style={{
                width: "80px",
                height: "80px",
                padding: "16px",
                borderRadius: "1000px",
                background: "#FFD182",
                margin: "0 auto",
              }}
            >
              <svg
                width="81"
                height="80"
                viewBox="0 0 81 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_9136_392"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="81"
                  height="80"
                >
                  <rect x="0.5" width="80" height="80" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_9136_392)">
                  <circle cx="41" cy="40" r="29" fill="#242424" />
                  <path
                    d="M40.3327 60.0003C41.4993 60.0003 42.4855 59.5975 43.291 58.792C44.0966 57.9864 44.4993 57.0003 44.4993 55.8337C44.4993 54.667 44.0966 53.6809 43.291 52.8753C42.4855 52.0698 41.4993 51.667 40.3327 51.667C39.166 51.667 38.1799 52.0698 37.3743 52.8753C36.5688 53.6809 36.166 54.667 36.166 55.8337C36.166 57.0003 36.5688 57.9864 37.3743 58.792C38.1799 59.5975 39.166 60.0003 40.3327 60.0003ZM40.4993 73.3337C35.8882 73.3337 31.5549 72.4587 27.4993 70.7087C23.4438 68.9587 19.916 66.5837 16.916 63.5837C13.916 60.5837 11.541 57.0559 9.79102 53.0003C8.04102 48.9448 7.16602 44.6114 7.16602 40.0003C7.16602 35.3892 8.04102 31.0559 9.79102 27.0003C11.541 22.9448 13.916 19.417 16.916 16.417C19.916 13.417 23.4438 11.042 27.4993 9.29199C31.5549 7.54199 35.8882 6.66699 40.4993 6.66699C45.1105 6.66699 49.4438 7.54199 53.4993 9.29199C57.5549 11.042 61.0827 13.417 64.0827 16.417C67.0827 19.417 69.4577 22.9448 71.2077 27.0003C72.9577 31.0559 73.8327 35.3892 73.8327 40.0003C73.8327 44.6114 72.9577 48.9448 71.2077 53.0003C69.4577 57.0559 67.0827 60.5837 64.0827 63.5837C61.0827 66.5837 57.5549 68.9587 53.4993 70.7087C49.4438 72.4587 45.1105 73.3337 40.4993 73.3337ZM40.8327 25.667C42.2216 25.667 43.4299 26.1114 44.4577 27.0003C45.4855 27.8892 45.9993 29.0003 45.9993 30.3337C45.9993 31.5559 45.6243 32.6392 44.8743 33.5837C44.1243 34.5281 43.2771 35.417 42.3327 36.2503C41.0549 37.3614 39.9299 38.5837 38.9577 39.917C37.9855 41.2503 37.4993 42.7503 37.4993 44.417C37.4993 45.1948 37.791 45.8475 38.3743 46.3753C38.9577 46.9031 39.6382 47.167 40.416 47.167C41.2493 47.167 41.9577 46.8892 42.541 46.3337C43.1243 45.7781 43.4993 45.0837 43.666 44.2503C43.8882 43.0837 44.3882 42.042 45.166 41.1253C45.9438 40.2087 46.7771 39.3337 47.666 38.5003C48.9438 37.2781 50.041 35.9448 50.9577 34.5003C51.8743 33.0559 52.3327 31.4448 52.3327 29.667C52.3327 26.8337 51.1799 24.5142 48.8743 22.7087C46.5688 20.9031 43.8882 20.0003 40.8327 20.0003C38.7216 20.0003 36.7077 20.4448 34.791 21.3337C32.8743 22.2225 31.416 23.5837 30.416 25.417C30.0271 26.0837 29.9021 26.792 30.041 27.542C30.1799 28.292 30.5549 28.8614 31.166 29.2503C31.9438 29.6948 32.7493 29.8337 33.5827 29.667C34.416 29.5003 35.1105 29.0281 35.666 28.2503C36.2771 27.417 37.041 26.7781 37.9577 26.3337C38.8743 25.8892 39.8327 25.667 40.8327 25.667Z"
                    fill="#FFD182"
                  />
                </g>
              </svg>
            </div>

            <p className="text-lg mt-4 font-semibold">
              Are you sure you want to sync this center document?
            </p>
            <div className="mt-4 flex justify-between gap-3">
              <button
                onClick={onClose}
                className="btn-cancel flex-1 rounded text-white hover:bg-gray-500"
              >
                No
              </button>
              <button
                onClick={onConfirm}
                className="btn-default flex-1 rounded p-4 text-white hover:bg-blue-700"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleSyncClick = (documentData) => {
    setSyncDocumentData(documentData);
    setIsSyncModalOpen(true);
  };

  const handleConfirmSync = async () => {
    setIsSyncModalOpen(false);
    try {
      await LockBoxService.handleSyncDocument(userId, syncDocumentData);
      setSyncSuccess(true);
      fetchData();
    } catch (error) {
      console.error("Error syncing document:", error);
    }
  };

  const syncButtonTemplate = (props) => {
    if (!props.copied_at) {
      return;
    }
    return (
      <button
        className="btn-sync cursor-pointer rounded bg-blue-500 px-3 py-1 text-white hover:bg-blue-600"
        onClick={() => handleSyncClick(props)}
      >
        Sync
      </button>
    );
  };

  return (
    <div
      className={`m-0 box-border flex w-[1648px] max-w-full flex-col items-start justify-start gap-2.5 px-2.5 py-[15px] leading-[normal] tracking-[normal] ${className}`}
    >
      <div className="mb-4 flex w-full flex-row items-center justify-between px-2.5">
        <div className="mt-2 flex flex-row items-start justify-start gap-1.5 py-0 pl-0 pr-5">
          <a className="relative inline-block min-w-[100px] text-left  text-xs font-medium leading-[16px] text-dodgerblue [text-decoration:none]">
            Partnership / View Documents
          </a>
        </div>
        <div className="disaster-name text-xl font-bold text-dodgerblue">
          {data.name_of_org}
        </div>
      </div>
      <section className="flex max-w-full flex-col items-start justify-start self-stretch bg-white">
        <header className="mb-2 flex flex-row items-center justify-between self-stretch">
          <div>
            <h2 className="mb-1 text-sm font-bold text-blue-500">
              CENTER DOCUMENTS
            </h2>
            <div className="flex flex-row items-start justify-start gap-1.5 text-xs text-darkslateblue">
              <Link
                to="/partnerships"
                className="font-500 flex items-center text-sm text-[#348BFF] hover:cursor-pointer"
              >
                <FaArrowLeft className="mr-1" />
                Back to list
              </Link>
            </div>
            {/* <p className="relative mt-2 text-sm font-medium leading-[21px]">
              The partner Lockbox is a secure space for nonprofit centers to
              store critical documents related to disaster preparedness and
              recovery.
            </p> */}
          </div>
        </header>
        {/* <div className="mt-2 flex w-full items-center justify-end">
          <button
            type="button"
            className="btn-default flex cursor-pointer gap-2 px-3 py-1.5"
            onClick={handleAddClickCenterDocument}
          >
            <FaPlus className="h-3 w-3" />
            Add
          </button>
        </div> */}
        <div className="mt-2 flex flex-col gap-4 self-stretch">
          <GridComponent
            ref={centerDocumentGridRef}
            dataSource={centerDocumentsData}
            allowSorting={true}
            sortSettings={sortSettings}
            editSettings={editing}
            filterSettings={filterSettings}
            allowFiltering={true}
            actionBegin={actionBeginCenterDocuments}
            actionComplete={actionCompleteCenterDocuments}
            allowPaging={true}
            pageSettings={pageSettings}
            showColumnMenu={true}
            columnMenuItems={columnMenuItems}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="documentsID"
                headerText="Documents ID"
                isPrimaryKey={true}
                visible={false}
              />
              <ColumnDirective
                field="type"
                headerText="Type"
                width="100"
                editType="dropdownedit"
                edit={typeParams}
              />
              <ColumnDirective
                field="description"
                headerText="Description"
                width="100"
              />
              <ColumnDirective
                field="date_inserted"
                headerText="Date Uploaded"
                width="100"
                format="MM/dd/yyyy"
                editType="datepickeredit"
                edit={datepickerparams}
              />
              <ColumnDirective
                field="photodocuments"
                headerText="Image"
                width="100"
                template={documentsTemplate}
                edit={documentsEdit}
              />
              <ColumnDirective
                field="center_signature_required"
                headerText="Center Signature Required"
                width="100"
                editType="booleanedit"
                visible={false}
              />
              <ColumnDirective
                field="partner_signature_required"
                headerText="Partner Signature Required"
                width="100"
                editType="booleanedit"
                visible={false}
              />
              <ColumnDirective
                field="status"
                headerText="Status"
                width="120"
                editType="dropdownedit"
                edit={statusParams}
                visible={false}
              />
              <ColumnDirective
                field="center_signature"
                headerText="Center Signature"
                width="100"
                template={signatureTemplateCenter}
                allowEditing={false}
              />
              <ColumnDirective
                field="partner_signature"
                headerText="Partner Signature"
                width="100"
                template={signatureTemplatePartner}
              />
              {/* <ColumnDirective
                headerText="Sync"
                width="50"
                template={syncButtonTemplate}
                allowEditing={false}
              />
              <ColumnDirective
                headerText="Actions"
                width="50"
                commands={[
                  {
                    type: "Edit",
                    buttonOption: {
                      content: '<i class="fas fa-edit"></i>',
                      cssClass: "e-outline custom-button",
                    },
                  },
                  {
                    type: "Delete",
                    buttonOption: {
                      content: '<i class="fas fa-trash-alt"></i>',
                      cssClass: "e-outline custom-button",
                    },
                  },
                ]}
              /> */}
            </ColumnsDirective>
            <Inject
              services={[
                Page,
                Edit,
                Toolbar,
                Sort,
                Filter,
                ColumnMenu,
                CommandColumn,
              ]}
            />
          </GridComponent>
        </div>
      </section>

      <FileDialog
        isOpen={isFileDialogOpen}
        onClose={() => setIsFileDialogOpen(false) + fetchData()}
        files={selectedFiles}
        currentIndex={currentFileIndex}
        setCurrentIndex={setCurrentFileIndex}
        dataset={selectedDataSet}
        userId={userId}
        userData={currentData}
        pov="center"
      />
      <ImageDialog
        isOpen={isImageDialogOpen}
        onClose={() => setIsImageDialogOpen(false)}
        images={selectedImages}
        currentIndex={currentImageIndex}
        setCurrentIndex={setCurrentImageIndex}
      />
      <SignatureDetailsModal
        selectedSignature={selectedSignature}
        onClose={closeSignatureDetails}
      />
    </div>
  );
};

export default PartnershipDocuments;
